import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import { fromPromise } from 'rxjs/observable/fromPromise';
import { CertificatesService } from './certificates.service';

@Injectable()
export class XmlService {

  constructor(
    private http: HttpClient,
    private certificateService: CertificatesService
  ) {
  }

  public prepareXml(data) {
    const url = environment.home_url + 'crypto/prepareJson';
    const self = this;
    return new Observable<Object>(observer => {
      const request = function (i = 1) {
        self.http.post(url, data).subscribe(
          response => {
            if (response === null) {
              if (i >= 5) {
                console.log('Не удалось получить xml');
                observer.complete();
              } else {
                request(++i);
              }
            } else {
              observer.next(response['data']);
              observer.complete();
            }
          },
          err => {
            if (i >= 5) {
              console.log(err);
              observer.complete();
            } else {
              request(++i);
            }
          }
        );

      };
      request();
    });

  }

  /**
   * @deprecated use CertificateService.signHash
   * @param xml
   * @param thumbprint
   * @param needEncode
   */
  public createSign(xml: string, thumbprint: string, needEncode = false) {
    if (needEncode) {
      xml = window.btoa(xml);
    }
    return fromPromise(this.certificateService.signHash(thumbprint, xml));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/xml.service.ts